<div class="d-flex flex-grow-1 flex-column justify-content-center">
  <div class="modal-body p-0" translate>
    <div id="diploma-container" class="diploma-container">
      <div class="diploma-info">
        <h3 class="diploma-user-name">
          <span class="me-1" [innerHTML]="diplomaService.currentUser?.field_first_name"></span>
          <span [innerHTML]="diplomaService.currentUser?.field_surname"></span>
        </h3>
        <div class="diploma-user-id">{{ diplomaService.currentUser?.uid }}</div>
        <h1 class="diploma-qualification" [innerHTML]="diplomaService.cert?.training_level"></h1>
        <div class="diploma-cert-date">{{ diplomaService.cert?.certification_date }}</div>
        <div class="diploma-cert-expiration">{{ diplomaService.expires }}</div>
      </div>
      <img class="diploma-img" src="/assets/images/diploma/diploma.jpg" />
    </div>
  </div>
</div>
